import type { InjectionKey } from 'vue'

import type { BatchProps } from './batch'

export interface BatchContext {
  size?: BatchProps['size']
}

export const batchContextKey: InjectionKey<BatchContext> =
  Symbol('batchContextKey')
